import classNames from 'clsx'
import { number, shape, string } from 'prop-types'

import colors from 'shared/config/cssVars/colors'

// See https://mui.com/components/progress/
const LoadingIndicator = ({ style, className, size, color, thickness }) => (
  <span
    className={classNames('a-LoadingIndicator', className)}
    style={{ ...style, width: size, height: size, color }}
    role="progressbar"
  >
    <svg viewBox="22 22 44 44">
      <circle
        cx="44"
        cy="44"
        r="20.2"
        fill="none"
        strokeWidth={thickness}
      ></circle>
    </svg>
  </span>
)

LoadingIndicator.propTypes = {
  style: shape({}),
  className: string,
  size: number,
  color: string,
  thickness: number,
}

LoadingIndicator.defaultProps = {
  style: {},
  className: undefined,
  size: 40,
  color: colors.blue,
  thickness: 3.6,
}

export default LoadingIndicator
